module.exports = __webpack_public_path__ + "static/media/green-mobile-small-blob.edd5c9e1.svg";